import React from "react";
import styles from "./CategoryListPage.module.css";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import history from "core/helper/Helper";
import { CategoryTable } from "admin/components/Category";
import { RouterPrivateName } from "shared/RouterPrivateName";

function CategoryListPage(props) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => history.push(RouterPrivateName.Category.Create.url)}
        >
          Thêm Sản Phẩm
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={() => history.push(RouterPrivateName.HomePage.url)}
        >
          Home
        </Button>
      </div>
      <CategoryTable />
    </div>
  );
}

CategoryListPage.propTypes = {};

export default CategoryListPage;
